define(['address','orderitems','orderSummary'], function(address, orderitems, ordersummary) {

	var ShippingCosts = {

		init : function(){

			console.log("INIT SHIPPING COSTS");

			if(typeof(checkoutPage) === "undefined"){
				return;
			}

			if(typeof(sessionStorage) === "undefined"){
				return;
			}

			// checkout pages review & shipping has been added to the existing check to display shipping cost inline in these pages too, as  in cart
			if(checkoutPage == "cart" || checkoutPage == "shipping" || checkoutPage == "review"){
			
				if(checkoutPage === "cart" || $('#order-review-options')){
					COSTCO.ShippingCosts.displayTotals();
				}				

		        $('body').bind('costco.ajax.content.update.end', function(event, response) {
		        	if (response.metadata.skipRefreshDisplayTotals != true) {
		        		if(checkoutPage === "cart" || $('#order-review-options')){
		        			COSTCO.ShippingCosts.displayTotals();	
		        		}
		        	}

		        });
		        if($('#ShopCartForm') && $('#ShopCartForm').length==1) {
		          COSTCO.ShippingCosts.validateShippingZip();
		        }
		        COSTCO.ShippingCosts.maskInput();
			}
			
			if(checkoutPage == "shipping" || checkoutPage == "review"){
				COSTCO.ShippingCosts.updateZipFromOrderAddress();
				
		        $('body').bind('costco.ajax.content.update.end', function(event, address) {
		        	COSTCO.ShippingCosts.updateZipFromOrderAddress();
		        });
			}
		},
		
		getOrderAddress : function(){
			
			if(typeof(orderAddress) !== "undefined" && typeof(orderAddress.PostalCode) !== "undefined"){
				return orderAddress;
			}
			
			return null;
			
		},
		
		updateZipFromOrderAddress : function(){
			
			var address = COSTCO.ShippingCosts.getOrderAddress();
			if(address != null){
				COSTCO.ShippingCosts.setAddress(address);
			}
			
		},

		getAddress : function(){
			
			if(typeof(sessionStorage) === "undefined"){
				return null;
			}

			var address = sessionStorage.getItem('shipping-costs-address');
			
			if(address != null && typeof(address) !== "undefined" && COSTCO.ShippingCosts.getOrderAddress() != null && 
					typeof(COSTCO.ShippingCosts.getOrderAddress()) !== "undefined" && JSON.parse(address).PostalCode === COSTCO.ShippingCosts.getOrderAddress().PostalCode){
				return JSON.parse(address);
			}
			
			return COSTCO.ShippingCosts.getOrderAddress();

		},

		setAddress : function(address){
			
			if(typeof(sessionStorage) === "undefined"){
				return;
			}
			
			sessionStorage.setItem('shipping-costs-address', JSON.stringify(address));
		},

		displayTotals : function(){

			var address = COSTCO.ShippingCosts.getAddress();
		
			if($('#shipCostsEnabledVal').val() == 'true') {
				
				if(address != undefined){
					COSTCO.ShippingCosts.call(address);
				} else if($.cookie('invCheckPostalCode') != null) {
					COSTCO.ShippingCosts.calculate();
				} else {
					$('#order-total-enter-text').removeClass('hide');
				}
			}
		},

		displayInput : function(){
			$('#order-total-enter-text, #order-estimated-zip').addClass('hide');
			if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CART_FEATURE_ENABLE === true) {
			  $('#order-estimated-shipping').addClass('hide');
			}
			$('#order-total-input').removeClass('hide');
			if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CART_FEATURE_ENABLE === true && $('#order-total-input').length > 0) {
			  $('#shipping-costs-zip').focus();
			}
		},

		zipText : "<h3 class=\"h8-style-guide pull-left\">{0} <button href=\"javascript:void(0);\" role=\"button\" type=\"button\" class=\"h8-style-guide-link btn-link\" aria-label= \"{1} " + messages.CHANGE_ZIP_CODE + "\" onclick=\"COSTCO.ShippingCosts.displayInput()\" automation-id=\"zipCodeLink\">{1}</button></h3>",

		displayZip : function(address){

			if($.cookie('invCheckPostalCode') !== null) {
				let postalCookie  = $.cookie('invCheckPostalCode').replace('+', ' ');
			}
			var text = COSTCO.util.messageFormat(COSTCO.ShippingCosts.zipText, messages.CHECKOUT_ORDER_TOTAL_SHIPP_MSG, typeof(postalCookie) !== "undefined" ? postalCookie : address.PostalCode);

			$('#order-total-enter-text').addClass('hide');
			$('#order-total-input').addClass('hide');
			$('#order-estimated-zip').html(text);
			$('.order-estimated').removeClass('hide');
			
			// if we update this, update global
			COSTCO.Header.updateGroceryShipPostalCodeDisplay();
		},

		display : function(orderItemArray, grocSurcharge){

			var totalShipping = 0;
			let freeGiftShipModeArray = document.getElementsByName('freeGiftShipMode');
			for(var i=0;i<orderItemArray.length;i++){
				totalShipping += COSTCO.ShippingCosts.processOrderItem(orderItemArray[i]);
				for(let j=0; j<freeGiftShipModeArray.length; j++) {
					if(freeGiftShipModeArray[j].id.includes(orderItemArray[i].orderItemId)) {
						let shippingMethodCostsArray = orderItemArray[i].shippingMethodCosts;
						for(let k=0; k<shippingMethodCostsArray.length; k++) {
							if(freeGiftShipModeArray[j].id.includes(shippingMethodCostsArray[k].id)) {
								freeGiftShipModeArray[j].value = shippingMethodCostsArray[k].amount +"_"+ freeGiftShipModeArray[j].id;
							}
						}
					}
				}
			}
			//if(checkoutPage === "review" || checkoutPage === "shipping"){
				//var displayTotalShip = COSTCO.util.formatMoney(totalShipping, true);
				//$('#ord_ship_charge').html(displayTotalShip);
			//}
			COSTCO.ShippingCosts.displayTotalCosts(totalShipping, grocSurcharge);

		},

		displayTotalCosts : function(amount, grocSurcharge){

			var amountZero = COSTCO.util.formatMoney(0, true);
			var formattedShipping = COSTCO.util.formatMoney(amount, true);

			if(orderStatic.totaldiscount == ""){
				orderStatic.totaldiscount = 0;
			}
			
			if(orderStatic.totalFreightSavings == ""){
				orderStatic.totalFreightSavings = 0;
			}
			
			if(grocSurcharge == ""){
				grocSurcharge = 0;
			}
			 
			//grocery Surcharge change - add surcharge to order total
			var total = parseFloat(orderStatic.ordertotal) + amount + parseFloat(orderStatic.totaldiscount) +parseFloat(orderStatic.totalFreightSavings)+ parseFloat(grocSurcharge) + parseFloat(orderStatic.promoAdjust);
			
			if(orderStatic.hasOwnProperty('frozenSurcharge')) {
				total += parseFloat(orderStatic.frozenSurcharge);
			}
			
			var formattedTotal = COSTCO.util.formatMoney(total, true);
			var formattedGrocerySurcharge = COSTCO.util.formatMoney(grocSurcharge, true);
			$('#order-estimated-shipping').find('.pull-right').html(formattedShipping);
			$('#order-grocery-surcharge').find('.pull-right, .summary-right').html(formattedGrocerySurcharge);
			$('#order-estimated-total').html(formattedTotal);
			$('#order-estimated-total-mobile').html(formattedTotal);
		},

		processOrderItem : function(orderItem){

			var shippingOrderItem = 0;
			var isShipModeSelected = false;
			var disableShipMethodCode = false;
			var numberOfShipMethodsHidden = 0;
			var hasLTLShipMethod = false;
	        var mapShipModes = new Map();
	        var isLtlShipModeSelected = false;
			
			for(var i=0; i<orderItem.shippingMethodCosts.length; i++){
				
				// only attempt to hide ship methods if there is more than 1
				if (orderItem.shippingMethodCosts.length > 1) {
					 var selector = COSTCO.util.messageFormat(COSTCO.OrderItems.shipMethodSelector, orderItem.orderItemId, orderItem.shippingMethodCosts[i].id);
						// if shipmode was selected and is now hidden, select the next one in this list. 
						 isShipModeSelected = $(selector).find("input:radio.shipModeId").prop("checked");
						 isLtlShipModeSelected = $('.ltl_pickup').find("input:radio.shipModeId").prop("checked");
						 disableShipMethodCode = orderItem.shippingMethodCosts[i].disableShipMethodCode;
						 if(orderItem.shippingMethodCosts[i].code == 'LPU'){
							 hasLTLShipMethod = true; 
						 }
						 mapShipModes.set(i,
								 {"hide" : disableShipMethodCode, 
							 	  "selected" : isShipModeSelected, 
							 	  "sequence" : orderItem.shippingMethodCosts[i].shipModeSequence, 
							 	  "selectorField" : selector,
							 	  "selectable" : false,
							 	  "selectedShipMethod":orderItem.shippingMethodCosts[i].code,
							 	  "ltlShipModeSelected" : isLtlShipModeSelected}); 
				}
				shippingOrderItem += COSTCO.ShippingCosts.processShippingMethod(orderItem.orderItemId, orderItem.shippingMethodCosts[i]);
			}
			
			// Get all hidden first
			for (i = 0 ; i < mapShipModes.size; i++) {
				if (mapShipModes.get(i).hide == 'true') {
					numberOfShipMethodsHidden++;	
				}
			}
			
			// Only run this code when at least one ship mode is expected to be hidden
			if (numberOfShipMethodsHidden > 0) {
				// When ALL are asked to be hidden, hide all except the first one (edge case)
				// When all delivery shipmodes are asked to be hidden and there is also an LPU shipmode, then show the LPU shipmode and the first delivery shipmode
				if ((numberOfShipMethodsHidden == mapShipModes.size && mapShipModes.size > 1) || (numberOfShipMethodsHidden == mapShipModes.size-1 && hasLTLShipMethod)) {
					mapShipModes.get(0).selectable = true;
					for (i = 1; i < mapShipModes.size; i++) {
						if(mapShipModes.get(i).ltlShipModeSelected == true && mapShipModes.get(i).selectedShipMethod == 'LPU'){
							mapShipModes.get(0).selectable = false;
							mapShipModes.get(i).selectable = true;
						}
						if(mapShipModes.get(i).hide == 'true'){
							COSTCO.OrderItems.disableShipMethodCode(mapShipModes.get(i).selectorField);
							if (mapShipModes.get(i).selected == true) {
								mapShipModes.get(i).selectable = false;
							}
						}
					}
				} 
				
				let needShipModeUpdate=true;
				// When we are hiding only some of the ship modes, if one of the hidden is selected, 
				// we need to select a non-hidden one - mark it as selectable
				var finalShipModeSelected = false;
				if (numberOfShipMethodsHidden < mapShipModes.size && !(numberOfShipMethodsHidden == mapShipModes.size-1 && hasLTLShipMethod)) {
					for (i = 0; i < mapShipModes.size; i++) {
						if (mapShipModes.get(i).hide == 'true') {
							COSTCO.OrderItems.disableShipMethodCode(mapShipModes.get(i).selectorField);
							if (mapShipModes.get(i).selected == true) {
								mapShipModes.get(i).selectable = false;
							}
						} else {
							// only allow one shipmode to be selectable
							if (!finalShipModeSelected) {
								mapShipModes.get(i).selectable = true;
								finalShipModeSelected = true;
							}
						}
						
						if(mapShipModes.get(i).selected == true && mapShipModes.get(i).hide=='false')
							needShipModeUpdate=false;	
						 
					}
				}
				
				
				if(needShipModeUpdate && !(numberOfShipMethodsHidden == mapShipModes.size-1 && hasLTLShipMethod))
				for (i = 0; i < mapShipModes.size; i++) {
					// after appropriate ship modes have been hidden, ensure the one left is selected
					// Only attempt to select the remaining ship mode if it is not already selected
					if (mapShipModes.get(i).selected == false && mapShipModes.get(i).selectable == true) {
						let checkboxSelection = $(mapShipModes.get(i).selectorField).find("INPUT.shipModeId")[0];
						let shipModeToSelect = $(mapShipModes.get(i).selectorField);
						$(checkboxSelection).prop("checked",true);
						let elemOrderItem = costcoStoreFeatures.WEBSITE_REDESIGN_V2_CART_FEATURE_ENABLE === true ? $(shipModeToSelect).attr("data-orderitem") : $(shipModeToSelect).parent().attr("data-orderitem");
						COSTCO.OrderItems.update_shipmode.call($(shipModeToSelect), $(shipModeToSelect).attr("data-shipmodeid"), elemOrderItem);
						break;
					}
				}
			}
			
			if(checkoutPage === "review" || checkoutPage === "shipping"){
				var amountZero = COSTCO.util.formatMoney(0, true);
				var shipCharge = COSTCO.util.formatMoney(shippingOrderItem, true);
				if(shipCharge === amountZero) {
					shipCharge = messages.RWD_SHIPPING_AND_HANDLING_INCLUDED;
				}
				$('#ship_charge_'+orderItem.orderItemId).html(shipCharge);
	    	}
		return shippingOrderItem;
		},

		processShippingMethod : function(orderItemId, shippingMethod){

			return orderitems.display_shipping_cost(orderItemId, shippingMethod);

		},
		
		call : function(address, modular=false, useZipCode=false,shipCalculateAction) {
			
			if(typeof(sessionStorage) !== "undefined"){
				if(sessionStorage.getItem('shipping-costs-orderItemId') !== null){
					var orderItemId = sessionStorage.getItem('shipping-costs-orderItemId');
					sessionStorage.removeItem('shipping-costs-orderItemId');
				}
				if(sessionStorage.getItem('shipping-costs-addressId') !== null){
					var addressId = sessionStorage.getItem('shipping-costs-addressId');
					sessionStorage.removeItem('shipping-costs-addressId');
				}
			}
			
			var requestData = [{
				Address : address,
				"orderItemId":orderItemId,
				"addressId": addressId,
				"useZipCode": useZipCode
			}]

			let url = '/AjaxShippingCostsControllerCmd';
			if (modular == true) {
				url = '/AjaxModularShippingCostsControllerCmd';
			}
			var oldZipcode = sessionStorage.getItem('oldZipcode');
			sessionStorage.removeItem('oldZipcode');
			var options = {
					url: url,
					method: "GET",
					dataType:'json',
					data: {'shippingCosts':encodeURIComponent(JSON.stringify(requestData)),'fromPage':checkoutPage,'oldZipcode':oldZipcode},
					done: function(response, textStatus, jqXHR, options){
						console.log("Retrieved Shipping Costs");

						let data = null;
						if (modular) {
							COSTCO.AjaxModular.ajax_update_default_done(response, textStatus, jqXHR, options);
							data = response.payload.data;
						} else {
							data = response;
						}
						if(data.orderErrMsgObj !== undefined && data.orderErrMsgObj["_ERR_CART_MSG.032"] !== undefined && data.orderErrMsgObj["_ERR_CART_MSG.032"] !== ''){
							$('#service-error').html(data.orderErrMsgObj["_ERR_CART_MSG.032"]);
							$('#service-error').removeClass('hide');							
							$('#order-total-input').removeClass('hide');
							if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CART_FEATURE_ENABLE === true && $('#order-total-input').length > 0) {
								  $('#shipping-costs-zip').focus();
							}							
						}	
						if(data.orderItemArray){
							/* Start - Grocery surcharge*/
							var grocSurcharge = 0;
							if(data.hasbab && data.grocsurcharge != 0){
								grocSurcharge = data.grocsurcharge;
							}
							/* End - Grocery surcharge*/
							var parsed = JSON.parse(data.orderItemArray);
							COSTCO.ShippingCosts.setAddress(address);
							orderitems.reset_shipping_cost_display();
							COSTCO.ShippingCosts.display(parsed, grocSurcharge);
							COSTCO.ShippingCosts.displayZip(address);							
						}
						
						/* Start - Grocery surcharge. Additional page check for cart page added as the method call failed when 
						 * trying to display shipping cost for grocery items. */
						if(data && data.hasbab && (checkoutPage == "cart" || (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE && checkoutPage == "review"))){
							COSTCO.ShippingCosts.dispGrocSurcharge(data);
						}					
						else{
					    	$('#order-grocery-surcharge').hide();
						}
						/* End - Grocery surcharge*/
						
						//contains alcohol checkbox content
						if($('#alcoholTermsErrCont').length > 0 && $('#alcoholTermsDiv').length > 0){
							if (data && !data.isAgeRestrictionCart) {
								$('#alcoholTermsErrCont').remove();
								$('#alcoholTermsDiv').remove();
								$('#tobaccoTermsDiv').remove();
								$('#tobaccoTermsErrCont').remove();
							}
						}
						
						// Narvar - EDD in Shipping Costs
						COSTCO.Header.startEDDMutationObserver();
						
						if(undefined !== shipCalculateAction && null !== shipCalculateAction && shipCalculateAction && typeof useZipCode !== 'undefined' && useZipCode === true){
							var calendarResponse = $('#calendarServiceResponse').val();
				            if(calendarResponse!= undefined){
					            document.getElementById("calendarServiceResponse").value ="";
				            }
				            COSTCO.EDDService.callEddService('addressChange');
				            if(checkoutPage === 'cart' || checkoutPage === 'review') {
				            	var pickUpAPIResp = $('#pickUpAPIResponses').val();
				          	  	if(pickUpAPIResp != undefined && pickUpAPIResp != null && pickUpAPIResp != '') {
				          	  		COSTCO.OrderItems.repaintPickUpMolecule(JSON.parse(pickUpAPIResp), true, true);
				          	  	}
				          	  	COSTCO.OrderItems.displayGlobalPickUpAlerts(false, true);
				            	 
				          	}
						}
					}
			}

			COSTCO.AjaxModular.ajax_update_state(options);
			

		},
		
		/* Start - Grocery */ 
		dispGrocSav : function(data) {
			console.log("Displaying Grocery Savings");
			var itemTotal;
			var grocSave;
			var orderTotal;
			if(data.itemtotal) {
				itemTotal = COSTCO.util.formatMoney(data.itemtotal, true);
				$('#order-estimated-subtotal').find('.pullright').html(itemTotal);
			}
			if(data.grocsav) {
				grocSave = COSTCO.util.formatMoney(data.grocsav, true);
				$('#grocery-saving').html(grocSave);
			}
			if(data.ordertotal) {
				orderTotal = COSTCO.util.formatMoney(data.ordertotal, true);
				$('#order-estimated-total').html(orderTotal);
			}
		},
		/* End - Grocery */
		
		maskInput : function() {
			var langId = COSTCO.util.getLangId();
	    	if (langId == -1) {
	    		$('#shipping-costs-zip').mask('00000-0000');
	    	}
	    	else if (langId == -24 || langId == -25) {
	    		$('#shipping-costs-zip').mask('S0S 0S0');
	    	}
		},

		/*
		 * Validate calculate zip code form input field. 
		 * Checks if cart redesign is disabled, it needs to validate a old form (#ShopCartForm)
		 */
		validateShippingZip : function() {
			if ($('#ship-cost-form').length > 0) {
				return COSTCO.ShippingCosts.validateShippingZipCodeForm();
			} else {
				return COSTCO.ShippingCosts.validateShippingZipCodeForm('#ShopCartForm');
			}
		},

		/*
		 * Validate calculate zip code form input field. 
		 * Defaulting to new shipping costs form, but can be overriden
		 */
		validateShippingZipCodeForm: function(shippingCostForm = '#ship-cost-form')  {
			$.validator.addMethod('regx', function(value, element, regex) {
				return regex.test(value);
			});
			var langId = COSTCO.util.getLangId();
			var regex = COSTCO.util.POSTAL_CODE_REGEX_US;
			if (langId == -24 || langId == -25) {
				regex = COSTCO.util.POSTAL_CODE_REGEX_CA;
			}

			return $(shippingCostForm).validate({
				focusInvalid: false,
				rules: {
					'zip-code': {required: true, regx: regex}
				},
				messages: {
					'zip-code': "Error: " + messages.ERR_BC_CART_ZIP
				},
				invalidHandler: (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CART_FEATURE_ENABLE === true) ? undefined : COSTCO.util.invalid_handler
			}).form();			
		},
		
		/*
		 * Validate calculate zip code from cookie
		 */
		validateShippingZipCodeCookie: function() {
			let langId = COSTCO.util.getLangId();
			let regexPattern = COSTCO.util.POSTAL_CODE_REGEX_US;
			if (langId == -24 || langId == -25) {
				regexPattern = COSTCO.util.POSTAL_CODE_REGEX_CA;
			}
			return regexPattern.test($.cookie('invCheckPostalCode'));
		},

		calculate : function(modular, useZipCode=false) {
			
			if (COSTCO.ShippingCosts.validateShippingZip() || COSTCO.ShippingCosts.validateShippingZipCodeCookie()) {
				
				let serviceToUpdateCookies = $('#isGeocodeService').val() != "true" ? COSTCO.util.callBingAndUpdateCookies : COSTCO.util.callGeocodeAPIAndUpdateCookies;
				let zipcode = $('#shipping-costs-zip').val();
				
				if(zipcode == undefined || zipcode === '') {
					zipcode = $.cookie('invCheckPostalCode');
				}
				

				serviceToUpdateCookies(zipcode)
		         .then((data) => {
		        	 let province = null;
		        	 let country = null;
		        	 let city = null;
		        	 if ($('#isGeocodeService').val() != "true") {
		        		 try {
								//Check out if country is Puerto Rico specific
								country = data.resourceSets[0].resources[0].address.countryRegionIso2;
								if (country != undefined && country === 'PR') {
									province = data.resourceSets[0].resources[0].address.countryRegionIso2;
								} else {
									province = data.resourceSets[0].resources[0].address.adminDistrict;
								}
				        	}catch(e){
				        		province = "";
				        	}
				        	try {
				        		city = data.resourceSets[0].resources[0].address.locality;
				        	}catch(e){
				        		city = "";
				        	}
				        	
				        	let langId = COSTCO.util.getLangId();
							country = 'US';
							if (langId == -24 || langId == -25) {
								country = 'CA';
							}
		        	 } else {
		        		 try {
		         			city = data[0].city;
		         			province = data[0].stateProvinceAbbreviation;
		         			if (province == null) {
		         				province = data[0].stateProvince;
		         			}
		         			country = data[0].country;
		        		 } catch (e) {
		        			 console.error('Error: '+ e.message);
		        		 }
		        	 }
		        	console.log("PROVINCE: " + province);
		        	console.log("CITY: " + city);
		        	console.log("COUNTRY: " + country);
		
		        	COSTCO.ShippingCosts.call(
		        			{City : '',
		        			 Line1 : '',
		        			 State : province,
		        			 PostalCode : zipcode,
		        			 Country : country
		        			}, modular, useZipCode,true
		        	)
		        })
			}
		},
		
		/* Start - Grocery Surcharge */ 
		dispGrocSurcharge : function(data) {
			console.log("Displaying Grocery Surcharge");		 
			var grocSurcharge;			
			if(data.grocsurcharge != -1) {
				grocSurcharge = COSTCO.util.formatMoney(data.grocsurcharge, true);
				$('#order-grocery-surcharge-value').html(grocSurcharge);
			}
		        let deliveryFee = COSTCO.util.formatMoney(data.grocsurcharge, false);
		        let currentOrder = data.groceryOrderTotal || 0.00;
	                let amountBase = data.groceryThreshold;
	                let amountToGoValue = data.groceryAmountToGo || data.groceryThreshold;
            
			$('#grocery-cart-left-to-go').replaceWith(COSTCO.util.tmpl('tmpl_cart_left_to_go', {
				currentOrder: parseFloat(currentOrder),
				amountBase: parseFloat(amountBase),
				amountToGo: parseFloat(amountToGoValue),
				deliveryFee: deliveryFee
	        }));
			$('.minibanner-help').popover({
		        trigger: 'focus',
		        placement: 'bottom',
		    });
		},
		/* End - Grocery Surcharge*/

	}

	if (typeof window.COSTCO === 'undefined') {
		window.COSTCO = new Object();
	}
	window.COSTCO.ShippingCosts = ShippingCosts;
	return ShippingCosts;
});


// WEBPACK FOOTER //
// ./js/checkout/shippingcosts.js